import { Card } from "@/src/components/cards";
import { openConfirmDialog } from "@/src/components/dialogs";
import { Hospitalisation, Patient, Admission } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getDayCount,
  getItemId,
  getUserId,
  getUserShortName,
  isToday,
} from "@/src/utils/utils";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";

export default function AdmissionCard({
  item,
  patient,
  parent,
  onClick,
  onChange,
}: {
  item: Admission;
  patient: Patient;
  parent: Hospitalisation;
  onClick: () => void;
  onChange: (item: Admission) => void;
}) {
  if (!item.id)
    return (
      <div
        className="card redish tcenter"
        onClick={async () => {
          let item: Admission = {
            type: "admission",
            patient,
            creator: getUserId(),
            parent,
            functionalSigns: [],
            physicalSigns: [],
            readBy: [getUserId()],
            confidentiality: getStandardConfidentiality(patient),
          };

          await openEvolutionItemStandardForm({
            item,
            patient,
            onConfirm: async (newItem) => {
              newItem = await apiFetch("admissions", "addOne", {
                admission: newItem,
              });
              onChange?.(newItem);
            },
          });
        }}
      >
        <div className="bold">Observation d&apos;admission</div>
        <div>Aucune donnée saisie</div>
      </div>
    );

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Observation d'admission"}
      subTitle={getUserShortName(item?.creator) || ""}
      onEdit={async () => {
        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("admissions", "addOne", {
              admission: newItem,
            });
            onChange?.(newItem);
          },
        });
      }}
      onClick={async () => {
        await onClick();
      }}
      onDelete={
        getUserId() == getItemId(item.creator) && isToday(item._date)
          ? async () => {
              await openConfirmDialog({
                content: "Voulez-vous vraiment supprimer cet élément ?",
                onConfirm: async () => {
                  await apiFetch("admissions", "deleteOne", {
                    id: item.id,
                  });
                  onChange?.(item);
                },
              });
            }
          : undefined
      }
    ></Card>
  );
}
